import moment     from 'moment';
import UtilsData  from '@/utilities/UtilsData';
import formatter  from '@/utilities/Formatter';

export class ModelFormatters {
  static ToUserData = {
    Passthrough: () => (key, value) => value,
    IntegerNumberAsString: () => function(key, value) {
      return formatter.formatAsNumber(value, { minSignsAfterDot: 0, maxSignsAfterDot: 0 });
    },
    DecimalNumberAsString: (minSignsAfterDot = 2, maxSignsAfterDot = 8) => function(key, value) {
      return formatter.formatAsNumber(value, { minSignsAfterDot, maxSignsAfterDot });
    },
    NumberAsDate: () => function(key, value) {
      return moment(value, 'YYYYMMDD').toDate();
    },
    Generic: () => function(key, value) {
      if (key == null) {
        return value;
      }
      if (key.endsWith('Date') && (value != null)) {
        return ModelFormatters.ToUserData.NumberAsDate()(key, value);
      } else if (typeof value === 'number') {
        return ModelFormatters.ToUserData.DecimalNumberAsString()(key, value);
      }
      return value;
    }
  }
  static ToModelData = {
    Passthrough: () => function(key, value) {
      return value
    },
    DecimalStringAsNumber: function(maxSignsAfterDot = 8) {
      return function(key, value) {
        return Number(UtilsData.castToNumber(value, maxSignsAfterDot))
      }
    },
    IntegerStringAsNumber: () => (key, value) => Number(UtilsData.castToNumber(value, 0)),
    DateAsNumber: () => (key, value) => Number(formatter.formatAsYYYYMMDD(value))
  }
}
